/**
 * --------------------------------------------------
 * Rithum Application
 * @module rithum
 * --------------------------------------------------
 */

// Import jQuery
import $ from 'jquery';

// expose to globals:
window.$      = jQuery;
window.jQuery = jQuery;

// Import required modules
import Navigation from './modules/navigation.js';
import Modal from './modules/modal.js';
import Sticky from './modules/sticky.js';
import Accordion from './modules/accordion.js';
import Search from './modules/search.js';

// temporary import
import CardList from './modules/card-list.js';
import Marketo from './modules/marketo.js';

// Import utility modules
import Visibility from './utils/visibility.js';

// Export the Rithum application
export default {
    ready() {
        $(document).ready(function () {

            // Initialize navigation module
            Navigation.setup();

            // Temporary: test cards module
            CardList.setup();

            // Initialize Marketo (temporary)
            Marketo.setup();

            // Initialize modal module
            Modal.init();

            // Initialize sticky module
            Sticky.setup();

            // Initialize accordion module
            Accordion.setup();

            // Initialize search module
            Search.setup();

            // Initialize visibility module
            Visibility.setup();
        });
    }
}